import { match } from 'ts-pattern';
import { useGetIGInsights } from '~/hooks/api/insights/useGetIGInsights';
import { useGetSnapchatInsights } from '~/hooks/api/insights/useGetSnapchatInsights';
import { useGetTTInsights } from '~/hooks/api/insights/useGetTTInsights';
import { useGetYTInsights } from '~/hooks/api/insights/useGetYTInsights';
import { Platform } from '~/screens/AddTalent/constants';

type Props = {
  insightId: string;
  platform: Platform;
};
export const useInsights = ({ insightId, platform }: Props) => {
  const igInsights = useGetIGInsights({
    id: platform === 'instagram' ? insightId : undefined,
  });
  const ttInsights = useGetTTInsights({
    id: platform === 'tiktok' ? insightId : undefined,
  });
  const ytInsights = useGetYTInsights({
    id: platform === 'youtube' ? insightId : undefined,
  });
  const snapchatInsights = useGetSnapchatInsights({
    id: platform === 'snapchat' ? insightId : undefined,
  });

  return match(platform)
    .with('instagram', () => igInsights)
    .with('tiktok', () => ttInsights)
    .with('youtube', () => ytInsights)
    .with('snapchat', () => snapchatInsights)
    .otherwise(() => null);
};
